import { Component, EventEmitter, Input, model } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'mic-year-scroller',
  imports: [MatIconButton, MatIcon, NgClass],
  templateUrl: './year-scroller.component.html',
  styleUrl: './year-scroller.component.scss'
})
export class YearScrollerComponent {
  year = model<number>(new Date().getFullYear());
  yearChanged = new EventEmitter();
  @Input() leftDisabled = false;
  @Input() rightDisabled = false;

  protected yearPlusOne() {
    this.year.update((curYear) => curYear + 1);
    this.yearChanged.emit();
  }

  protected yearMinusOne() {
    this.year.update((curYear) => curYear - 1);
    this.yearChanged.emit();
  }
}
